<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256"  @close="CancelOK"
  >
    <el-row>
      <el-col :span="8">
        <div class="search-content">
          <div class="toobar">
            <el-input style="width:200px;"
                      placeholder="请输入型号"
                      clearable onfocus="this.select()"
                      prefix-icon="el-icon-search"
                      v-model="searchdata">
            </el-input>
          </div>
        </div>
        <div style="background-color: #F2F2F2;">
          <el-row>
            <div style="height: 30px">库存范围</div>
            <div style="margin: 0 auto">
              <el-input style="width: 20%" size="medium" v-model="minikucun" clearable></el-input>
              -
              <el-input style="width:  20%" size="medium" v-model="maxkucun" clearable></el-input>
            </div>
          </el-row>
          <el-row v-for="(item,index) in options" :key="index">
            <div style="height: 30px;float: left;">{{item.label}}</div>
            <div style="height: 30px;float: right;width: 60px">  <el-button size="mini" round @click="clearSelect(item.options,item.label)">重置</el-button>
            </div>
            <ul style="margin: 0 auto">
              <li style="" v-for="o in item.options" v-if="!o.enabled||!enabled||o.enabled.toString()==enabled.toString()" @click="son(o,item.label)"
                  :class='o.type?"selectedtrue":"selectedfalse"'>
                {{o.label}}
              </li>
            </ul>
          </el-row>
        </div>
      </el-col>
      <el-col :span="15" style="margin-left: 5px">
        <div class="grid-content bg-purple-light">
          <div class="search-content">
            <el-col class="toobar">
              <el-row>
                <el-select v-model="enabled" style="width:110px">
                  <el-option key="" label="全部" value="">
                  </el-option>
                  <el-option key="0" label="下架" value="0">
                  </el-option>
                  <el-option key="1" label="上架" value="1">
                  </el-option>
                </el-select>
                &nbsp; &nbsp;排序：
                <el-select v-model="sortbyvalue" style="width:110px" @change="sortTable">
                  <el-option label="库存：大->小" value="1">
                  </el-option>
                  <el-option label="库存：小->大" value="2">
                  </el-option>
                  <el-option label="型号" value="3">
                  </el-option>
                  <el-option label="色号" value="4">
                  </el-option>
                </el-select>
                &nbsp; &nbsp;总数：<b>{{totalN}}</b>&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="showprice">总价：<b>{{totalmoney}}</b></span>
                <el-input v-model="number" @change="batchinput" style="width: 20%;float: right;" placeholder="批量输入数量"
                          clearable @clear="clearnumber"></el-input>
              </el-row>
            </el-col>
          </div>
          <el-table :data="tableData.filter(data =>
          (!searchdata || data.model.toLowerCase().includes(searchdata.toLowerCase()))&&
          (!enabled||data.enabled==enabled)&&
          (!minikucun||data.storenum>=minikucun)&&
          (!maxkucun||data.storenum<=maxkucun)&&
          (!modelString||modelString.toLowerCase().indexOf(';'+data.model.toLowerCase()+';')>-1)&&
          (!colorString||colorString.toLowerCase().indexOf(';'+data.color.toLowerCase()+';')>-1)
          )"
                    :height="tableHeight(155)" ref="table1"
                    size="mini" stripe border style="width: 100%;" >
            <el-table-column
              width="50"
              label="序号"
              type="index"
              :index="indexMethod"
              align="center">
            </el-table-column>
            <el-table-column
              label=""
              align="center"
              width="50"
              header-align="center">
              <template slot-scope="scope">
               <i class="el-icon-success" style="color:#409EFF;font-size:18px" v-if="scope.row.totalnumber>0"></i>
              </template>
            </el-table-column>
            <el-table-column
              prop="seedname"
              label="名称"
              align="left" sortable
              header-align="center">
              <template slot-scope="scope">
                <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 100%;height:24px;" :title="scope.row.seedname">
                  {{scope.row.seedname}}
                </div>
              </template>
            </el-table-column>
            <!--<el-table-column-->
              <!--prop="seedcode"-->
              <!--label="编码"-->
              <!--align="left"-->
              <!--header-align="center"-->
              <!--width="95">-->
            <!--</el-table-column>-->
            <el-table-column
              prop="model"
              label="型号"
              align="left"
              header-align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="color"
              label="色号"
              align="left"
              header-align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="goodyear"
              label="年份"
              align="left" width="60"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="costprice" v-if="showprice"
              label="单价"
              align="left" width="60"
              header-align="center">
            </el-table-column>
            <el-table-column
              v-if="isShowStore"
              prop="storenum"
              label="库存"
              align="left"
              header-align="center"
              width="80">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.totalnumber>0&&scope.row.totalnumber>scope.row.storenum" type="danger">{{scope.row.storenum}}</el-tag>
                <span v-else>{{scope.row.storenum}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="数量"
              align="center"
              width="90"
              header-align="center">
              <template slot-scope="scope">
                <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                          :ref='scope.row.id'
                          onfocus="this.select()" @change="subNum"
                          @keyup.enter.native="validateCounts(scope.row,scope.$index, $event)"
                          @keyup.down.native="validateCounts(scope.row,scope.$index, $event)"
                          @keyup.up.native="validateCounts(scope.row,scope.$index, $event)"></el-input>
              </template>
            </el-table-column>
            <!--<el-table-column-->
            <!--prop="lname"-->
            <!--label="分类"-->
            <!--align="left"-->
            <!--header-align="center"-->
            <!--width="200">-->
            <!--</el-table-column>-->

          </el-table>
        </div>
      </el-col>

    </el-row>
    <div slot="footer" class="dialog-footer no-print">
      <el-button type="primary" @click="SelectOK">确 定</el-button>
      <el-button @click="CancelOK">关 闭</el-button>
      <el-button type="warning" @click="productimport($event)" size="small">导入</el-button>
      <a href="./static/file/镜架数量导入模板.xls" download="C:/Users/Public">下载模板</a>
      <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
    </div>
  </el-dialog>
</template>


<script>
  import {getDetail} from '@/api/set/jxcgoodscategory';
  import {customerseedcodelist} from '@/api/set/goodsprice'
  import {getscreen, getquerygoodsv2} from '@/api/set/jxcgooddetail'
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore'

  export default {
    name: 'BatchBuyFormProperties',
    data() {
      return {
        dialogFormVisible: false,
        totalN:0,
        totalmoney:0,
        SelectionChange: [],//选择后的商品
        tableData: [],//筛选后所展示的数据
        searchdata: '',//搜索条件
        nostock: '',//是否备货
        formproperty: [],//表单属性
        enabled: '1',//0下架 1上架
        options: [],//options: [{ label: '', options: [{label: '',type:false}]}],
        query: [],
        sortbyvalue:1,
        showprice:false,
        categorycode: '',
        pseedcodes: [],
        customerserial: '',
        isShowStore: true,//控制是否显示库存
        minikucun: '',//最小库存范围
        maxkucun: '',//最大库存范围
        modelString:'',
        colorString:'',
        oldtableData: [],
        number: '',//批量输入数
        allmodel:''
      }
    },
    methods: {
      afterclose(){

      },
      checkShow(data) {
        return (!this.searchdata || data.model.toLowerCase().includes(this.searchdata.toLowerCase())) &&
          (!this.enabled || data.enabled == this.enabled) &&
          (!this.minikucun || data.storenum >= this.minikucun) &&
          (!this.maxkucun || data.storenum <= this.maxkucun) &&
          (!this.modelString || this.modelString.toLowerCase().indexOf(';' + data.model.toLowerCase() + ';') > -1) &&
          (!this.colorString || this.colorString.toLowerCase().indexOf(';' + data.color.toLowerCase() + ';') > -1);
      },
      batchinput() {
        for (let i in this.tableData) {
          if (this.checkShow(this.tableData[i]))
            this.tableData[i].totalnumber = this.number
        }
        this.subNum();
      },
      subNum(){
        this.totalN=0;
        this.totalmoney=0;
        for (let i in this.tableData) {
          if(this.tableData[i].totalnumber) {
            this.totalN += parseInt(this.tableData[i].totalnumber)
            if (this.tableData[i].costprice)
              this.totalmoney += parseFloat(this.tableData[i].totalnumber) * parseFloat(this.tableData[i].costprice);
          }
        }
        this.totalmoney=this.totalmoney.toFixed(2);
      },
      //清除所有数量
      clearnumber() {
        this.batchinput();
      },
      //回车跳入下一行
      validateCounts(row, index, e) {
        var begin=false;
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键

          console.log(this.tableData)
          console.log(index)
          for(var i=0;i<this.tableData.length;i++) {
            if(this.tableData[i].id==row.id) {
              begin = true;
              continue;
            }

            if(begin&&this.checkShow(this.tableData[i])){
              this.$refs[row.id].blur()
              console.log(this.tableData[i].id)
              this.$refs[this.tableData[i].id].focus();
              break;
            }
          }

        } else if (keyCode == 38) {//上方向键
          for(var i=this.tableData.length-1;i>=0;i--) {

            if(this.tableData[i].id==row.id) {
              begin = true;
              continue;
            }

            if(begin&&this.checkShow(this.tableData[i])){
              this.$refs[row.id].blur()
              this.$refs[this.tableData[i].id].focus();
              break;
            }
          }
          // this.$refs[Object.keys(this.$refs)[index - 1]].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        return index + 1;
      },
      //点击变色
      son(item,label) {
        if (item.type != !item.type) {
          item.type = !item.type
        }
        if (label == '型号') {
          if (item.type) {
            this.modelString += ';' + item.label + ';';
          } else {
            this.modelString = this.modelString.replace(';' + item.label + ';', '');
          }
        }else{
          if (item.type) {
            this.colorString += ';' + item.label + ';';
          } else {
            this.colorString = this.colorString.replace(';' + item.label + ';', '');
          }
        }
      },
      clearSelect(items,label) {
        for (let i in items) {
          items[i].type = false;
        }
        if (label == '型号')
          this.modelString = ''
        else
          this.colorString = ''
      },
      //商品导入
      productimport() {
        this.$refs.fileupload.value = ""
        this.$refs.fileupload.click();
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              data.forEach((item) => {
                var model=item['型号']
                var color=item['色号']?item['色号']:item['规格']
                for (let i in this.tableData) {
                  if (this.tableData[i].model ==model&&this.tableData[i].color==color) {
                    this.tableData[i].totalnumber = item['数量']
                    break;
                  }
                }
              })
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      CancelOK(){
        this.$emit("afterSelectCode", [])
        this.dialogFormVisible = false;
      },
      //确定选择后将商品传到采购页面
      SelectOK() {//多选
        var arr = []
        for (let i in this.tableData) {
          if (parseInt(this.tableData[i].totalnumber) != 0) {
            arr.push(this.tableData[i]);
          }
        }
        this.$emit("afterSelectCode", arr)
        this.dialogFormVisible = false;
      },
      //批量采购页面选择页面调用的方法seedcodeData=所有商品
      initData(isShowStore, categorycode, cangkucode, seedcodeData, customerserial) {
        this.initForm()
        this.customerserial = customerserial
        this.categorycode = categorycode
        this.cangkucode = cangkucode
        this.isShowStore = isShowStore

        var seedcodes = ','
        //筛选条件
        var modelOptions = {label: '型号', options: []}
        var colorOptions = {label: '色号', options: []}
        if (seedcodeData.length == 0)
          return;
        var colors=';'

        var index = 0;
        for (let i in seedcodeData) {
          var enabled = seedcodeData[i].enabled.toString();
          seedcodes += seedcodeData[i].seedcode + ','
          modelOptions.options.push({label: seedcodeData[i].model, type: false, enabled: enabled})
          if (!this.showprice && seedcodeData[i].costprice > 0) this.showprice = true;
          if (seedcodeData[i].color) {
            var c = seedcodeData[i].color.split(';')
            for (let j in c) {
              if (c[j]) {
                if (colors.indexOf(';' + c[j] + ';') == -1) {
                  colors += c[j] + ';';
                  colorOptions.options.push({label: c[j], type: false})
                }
                this.tableData.push({
                  color: c[j],
                  model: seedcodeData[i].model,
                  seedcode: seedcodeData[i].seedcode,
                  seedname: seedcodeData[i].seedname,
                  categorycode: seedcodeData[i].categorycode,
                  enabled: enabled,
                  totalnumber: 0,
                  storenum: 0,
                  goodyear: seedcodeData[i].goodyear,
                  costprice: seedcodeData[i].costprice,
                  id: 'num' + index
                })
                index++;
              }
            }
          } else {
            this.tableData.push({
              color: '',
              model: seedcodeData[i].model,
              seedcode: seedcodeData[i].seedcode,
              seedname: seedcodeData[i].seedname,
              categorycode: seedcodeData[i].categorycode,
              enabled: enabled,
              totalnumber: 0,
              storenum: 0,
              goodyear: seedcodeData[i].goodyear,
              costprice: seedcodeData[i].costprice,
              id: 'num' + index
            })
            index++;
          }
        }
        modelOptions.options.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        colorOptions.options.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        this.options.push(modelOptions);
        this.options.push(colorOptions);
        this.dialogFormVisible = true;

        if (isShowStore) {
          this.bindStore(seedcodes)
        } else {
          this.sortbyvalue = 3;
          this.sortTable();
        }
      },
      bindStore(seedcodes) {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        getGoodsListWithStoreDetail({
          seedcode: seedcodes,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1, nobuynum: '1'
        }).then(resStore => {
          var storeData = resStore.data.obj
          for (let orderIndex in this.tableData) {
            for (let storeIndex in storeData) {
              var storeRow = storeData[storeIndex];
              if(!storeData[storeIndex].packagesize)
                continue;

              var packagesize = JSON.parse(storeData[storeIndex].packagesize);

              if (this.tableData[orderIndex].seedcode == storeRow.seedcode &&
                this.tableData[orderIndex].model == packagesize.M &&
                this.tableData[orderIndex].color == packagesize.C) {

                this.tableData[orderIndex].storenum = storeRow.subtractnum - storeRow.deliverying + storeRow.transfernum;//库存数量
                if (this.tableData[orderIndex].storenum == undefined) {
                  this.tableData[orderIndex].storenum = 0
                }

                break;
              }
            }
          }

         this.sortTable();

        }).catch((error) => {
          console.log(error)
        });
      },
      sortTable(){
        var obj=this.sortbyvalue.toString();
        this.tableData.sort(function (a, b) {
          let x = a.storenum
          let y = b.storenum

          switch (obj){
            case "1"://库存大-->小

              if (x == y) {
                if (a.model == b.model)
                  return a.color.localeCompare(b.color);
                else
                  return a.model.localeCompare(b.model);
              }
              return ((x > y) ? -1 : (x < y) ? 1 : 0)

              break;
            case "2"://库存小-->大

              if (x == y) {
                if (a.model == b.model)
                  return a.color.localeCompare(b.color);
                else
                  return a.model.localeCompare(b.model);
              }
              return ((x < y) ? -1 : (x > y) ? 1 : 0)

              break;
            case "3"://型号
              if (a.model == b.model)
                return a.color.localeCompare(b.color);
              else
                return a.model.localeCompare(b.model);
              break;
            case "4"://色号
              if (a.color == b.color)
                return a.model.localeCompare(b.model);
              else
                return a.color.localeCompare(b.color);
              break;
          }

        });
      },
      initForm() {
        this.sortbyvalue = '1';
        this.tableData = []
        this.formproperty = ''
        this.searchdata = ''
        this.SelectionChange = []
        this.enabled = '1'
        this.options = []
        this.oldtableData = []
        this.modelString = ''
        this.colorString = ''
        this.totalN = 0
        this.showprice = false;
      }
    }
    ,
    mounted() {
    }
    ,
    components: {}

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

  .selectedtrue {
    text-align: center;
    float: left;
    cursor: pointer;
    width: 60px;
    height: 25px;
    line-height: 25px;
    margin-left: 5px;
    margin-bottom: 3px;
    border: 1px #4A99FA solid;
    color: #4A99FA;
    background-color: white;
  }

  .selectedfalse {
    text-align: center;
    float: left;
    cursor: pointer;
    width: 60px;
    height: 25px;
    line-height: 25px;
    margin-left: 5px;
    margin-bottom: 3px;
    border: 1px #f2f2f2 solid;
    background-color: white;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BatchBuyFormProperties.vue